import type { ApolloQueryResult } from '@apollo/client'

import type {
  getReturnCase,
  getReturnCase_returnCaseItem,
  getReturnCaseVariables,
} from 'Constants/graphql/queries/detail/__generated__/getReturnCase'

export interface ReturnDetailsCardProps {
  returnCase: getReturnCase_returnCaseItem
  title: string
  refetch: (
    variables?: Partial<getReturnCaseVariables>,
  ) => Promise<ApolloQueryResult<getReturnCase>>
}

export enum ReturnDetailsCardModalTypes {
  CreateReturnLabelModal,
  UpdateTrackingModal,
}
